import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getApiBaseUrl } from '../config/api';
import useLiveRefresh from '../hooks/useLiveRefresh';
import './GroupsFeedSidebar.css';

function SeeMoreChevron() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M9 6l6 6-6 6" />
    </svg>
  );
}

/**
 * Home-rail Learning Progress — compact summary only (full journey via See more).
 */
export default function LearningProgressFeedSidebar({ user }) {
  const API_URL = getApiBaseUrl();
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(
    async (options = {}) => {
      if (!user?.id) {
        setSummary(null);
        setLoading(false);
        return;
      }
      const silent = options.silent === true;
      if (!silent) setLoading(true);
      try {
        const res = await fetch(
          `${API_URL}/get_my_learning.php?user_id=${user.id}`
        );
        const data = await res.json();
        if (data.success) {
          setSummary(data.summary || null);
        } else if (!silent) {
          setSummary(null);
        }
      } catch (err) {
        console.error('Learning progress sidebar error:', err);
        if (!silent) setSummary(null);
      } finally {
        if (!silent) setLoading(false);
      }
    },
    [API_URL, user?.id]
  );

  useEffect(() => {
    load();
  }, [load]);

  useLiveRefresh(() => load({ silent: true }), 25000, Boolean(user?.id));

  if (!user?.id) return null;

  return (
    <aside className="gfs-panel">
      <div className="gfs-header">
        <h2 className="gfs-title">Learning Progress</h2>
        <Link to="/my-learning" className="gfs-see-more">
          See more
          <SeeMoreChevron />
        </Link>
      </div>

      <div className="gfs-learning-summary" style={{ paddingBottom: 14 }}>
        {loading ? (
          <span>Loading…</span>
        ) : summary ? (
          <>
            <span>
              <strong>{summary.in_progress ?? 0}</strong> in progress
            </span>
            <span className="gfs-learning-dot">·</span>
            <span>
              <strong>{summary.hours_this_week ?? 0}h</strong> this week
            </span>
            <span className="gfs-learning-dot">·</span>
            <span>
              <strong>{summary.active_goals ?? 0}</strong> goals
            </span>
          </>
        ) : (
          <Link to="/my-learning" className="gfs-manage">
            Start your journey
          </Link>
        )}
      </div>
    </aside>
  );
}
